module.exports = __webpack_public_path__ + "img/smeetz_logo_black.5cc3e1b2.png";